/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ErrorInputs */



/**
* | output |
* | --- |
* | "Error" |
*
* @param {ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error = /** @type {((inputs?: ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गलती")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro")
	return /** @type {LocalizedString} */ ("Error")
});